export default (messages, format) =>
  messages.reduce((string, message) => {
    if (message.type === 'patient' || message.deletedAt) return string;
    const fullNameSender = message.user.fullNameWithTitle || 'unknown';
    const time = format(message.time, 'DD.MM.YYYY HH:mm:ss');

    const files = message.file || message.files;
    let content = [
      files
        ? []
            .concat(files)
            .map(m => m.name)
            .join(', ')
        : '',
      message.text ? message.text : '',
    ];

    content = (message.files ? content.reverse() : content).join(' ').trim();

    return `${string}${time}, ${fullNameSender}:\n${content}\n\n`;
  }, '');
